/* eslint-disable @typescript-eslint/typedef */
// Generated Figma variables (from local JSON)
// Do not add anything manually, all changes will be overwritten on the next generation.

// Primitive tokens (per brand); keys should appear in at least one other brand.
export const primitiveTsCssVars = {
  'accent-0': 'rgba(246, 40, 40, 0.0)',
  'accent-10': '#feebeb',
  'accent-100': 'rgba(246, 40, 40, 0.10)',
  'accent-20': '#fcbbbb',
  'accent-30': '#fa8a8a',
  'accent-40': '#f85959',
  'accent-50': '#f62828',
  'accent-60': '#e10a0a',
  'accent-70': '#b00808',
  'accent-80': '#7f0606',
  'accent-90': '#4e0303',
  'black-0': 'rgba(10, 10, 10, 0.0)',
  'black-10': 'rgba(10, 10, 10, 0.10)',
  'black-100': '#0a0a0a',
  'black-20': 'rgba(10, 10, 10, 0.20)',
  'black-30': 'rgba(10, 10, 10, 0.30)',
  'black-40': 'rgba(10, 10, 10, 0.40)',
  'black-50': 'rgba(10, 10, 10, 0.50)',
  'black-60': 'rgba(10, 10, 10, 0.60)',
  'black-70': 'rgba(10, 10, 10, 0.70)',
  'black-80': 'rgba(10, 10, 10, 0.80)',
  'black-90': 'rgba(10, 10, 10, 0.90)',
  'brand-0': 'rgba(246, 40, 40, 0.0)',
  'brand-10': '#feebeb',
  'brand-100': 'rgba(246, 40, 40, 0.10)',
  'brand-20': '#fcbbbb',
  'brand-30': '#fa8a8a',
  'brand-40': '#f85959',
  'brand-50': '#f62828',
  'brand-60': '#e10a0a',
  'brand-70': '#b00808',
  'brand-80': '#7f0606',
  'brand-90': '#4e0303',
  'error-0': 'rgba(246, 40, 40, 0.0)',
  'error-10': '#feebeb',
  'error-100': 'rgba(246, 40, 40, 0.10)',
  'error-20': '#fcbbbb',
  'error-30': '#fa8a8a',
  'error-40': '#f85959',
  'error-50': '#f62828',
  'error-60': '#e10a0a',
  'error-70': '#b00808',
  'error-80': '#7f0606',
  'error-90': '#4e0303',
  'info-0': 'rgba(51, 68, 255, 0.0)',
  'info-10': '#d6daff',
  'info-100': 'rgba(51, 68, 255, 0.10)',
  'info-20': '#adb4ff',
  'info-30': '#858fff',
  'info-40': '#5c69ff',
  'info-50': '#3344ff',
  'info-60': '#2936cc',
  'info-70': '#1f2999',
  'info-80': '#141b66',
  'info-90': '#0a0e33',
  'neutral-0': 'rgba(10, 10, 10, 0.0)',
  'neutral-10': '#f0f0f0',
  'neutral-100': 'rgba(10, 10, 10, 0.10)',
  'neutral-20': '#d6d6d6',
  'neutral-30': '#bdbdbd',
  'neutral-40': '#a3a3a3',
  'neutral-50': '#8a8a8a',
  'neutral-60': '#707070',
  'neutral-70': '#575757',
  'neutral-80': '#242424',
  'neutral-85': '#191919',
  'neutral-90': '#0a0a0a',
  'radius-1': 4,
  'radius-10': 56,
  'radius-2': 8,
  'radius-3': 12,
  'radius-4': 16,
  'radius-5': 20,
  'radius-6': 24,
  'radius-7': 32,
  'radius-8': 40,
  'radius-9': 48,
  'radius-999': 999,
  'space-1': 4,
  'space-10': 56,
  'space-11': 64,
  'space-12': 80,
  'space-13': 96,
  'space-14': 128,
  'space-15': 160,
  'space-16': 192,
  'space-17': 224,
  'space-18': 256,
  'space-19': 512,
  'space-2': 8,
  'space-3': 12,
  'space-4': 16,
  'space-5': 20,
  'space-6': 24,
  'space-7': 32,
  'space-8': 40,
  'space-9': 48,
  'success-0': 'rgba(76, 175, 80, 0.0)',
  'success-10': '#dbefdc',
  'success-100': 'rgba(76, 175, 80, 0.10)',
  'success-20': '#b7dfb9',
  'success-30': '#94cf96',
  'success-40': '#70bf73',
  'success-50': '#4caf50',
  'success-60': '#3d8c40',
  'success-70': '#2e6930',
  'success-80': '#1e4620',
  'success-90': '#0f2310',
  'warning-0': 'rgba(255, 152, 0, 0.0)',
  'warning-10': '#ffeacc',
  'warning-100': 'rgba(255, 152, 0, 0.10)',
  'warning-20': '#ffd699',
  'warning-30': '#ffc166',
  'warning-40': '#ffad33',
  'warning-50': '#ff9800',
  'warning-60': '#cc7a00',
  'warning-70': '#995b00',
  'warning-80': '#663d00',
  'warning-90': '#331e00',
  'white-0': 'rgba(255, 255, 255, 0.0)',
  'white-10': 'rgba(255, 255, 255, 0.10)',
  'white-100': '#ffffff',
  'white-20': 'rgba(255, 255, 255, 0.20)',
  'white-30': 'rgba(255, 255, 255, 0.30)',
  'white-40': 'rgba(255, 255, 255, 0.40)',
  'white-50': 'rgba(255, 255, 255, 0.50)',
  'white-60': 'rgba(255, 255, 255, 0.60)',
  'white-70': 'rgba(255, 255, 255, 0.70)',
  'white-80': 'rgba(255, 255, 255, 0.80)',
  'white-90': 'rgba(255, 255, 255, 0.90)',
  'yellow-0': 'rgba(251, 205, 0, 0.0)',
  'yellow-10': '#fffefa',
  'yellow-100': 'rgba(251, 205, 0, 0.10)',
  'yellow-20': '#fff4c7',
  'yellow-30': '#ffeb94',
  'yellow-40': '#ffe161',
  'yellow-50': '#ffd72e',
  'yellow-60': '#fbcd00',
  'yellow-70': '#c7a100',
  'yellow-80': '#947800',
  'yellow-90': '#614e00'
} as const;

// Semantic tokens; the same keys must exist for every brand (values may differ).
export const semanticTsCssVars = {
  'background-accent': '#f62828',
  'background-body': '#f0f0f0',
  'background-brand': '#f62828',
  'background-primary': '#ffffff',
  'background-primary-inverse': '#0a0a0a',
  'background-primary-object': '#ffffff',
  'background-quaternary': '#bdbdbd',
  'background-secondary': '#f0f0f0',
  'background-state-accent': '#f62828',
  'background-state-accent-subtle': '#feebeb',
  'background-state-brand': '#f62828',
  'background-state-brand-subtle': '#feebeb',
  'background-state-error': '#f62828',
  'background-state-error-subtle': '#feebeb',
  'background-state-info': '#3344ff',
  'background-state-info-subtle': '#d6daff',
  'background-state-neutral': 'rgba(10, 10, 10, 0.60)',
  'background-state-neutral-subtle': '#d6d6d6',
  'background-state-success': '#4caf50',
  'background-state-success-subtle': '#dbefdc',
  'background-state-warning': '#ff9800',
  'background-state-warning-subtle': '#ffeacc',
  'background-tertiary': '#d6d6d6',
  'border-accent': '#f62828',
  'border-brand': '#f62828',
  'border-primary': '#d6d6d6',
  'border-secondary': '#0a0a0a',
  'border-state-error': '#f62828',
  'border-state-info': '#3344ff',
  'border-state-success': '#4caf50',
  'border-state-warning': '#ff9800',
  'border-tertiary': '#0a0a0a',
  'components-badges-badge-bg-error': '#feebeb',
  'components-badges-badge-bg-info': '#d6daff',
  'components-badges-badge-bg-success': '#dbefdc',
  'components-badges-badge-bg-warning': '#ffeacc',
  'components-badges-badge-fg-error': '#f62828',
  'components-badges-badge-fg-info': '#3344ff',
  'components-badges-badge-fg-success': '#4caf50',
  'components-badges-badge-fg-warning': '#ff9800',
  'components-badges-badge-icon-error-bg': '#feebeb',
  'components-badges-badge-icon-error-fg': '#f62828',
  'components-badges-badge-icon-info-bg': '#d6daff',
  'components-badges-badge-icon-info-fg': '#3344ff',
  'components-badges-badge-icon-neutral-bg': '#d6d6d6',
  'components-badges-badge-icon-neutral-fg': '#575757',
  'components-badges-badge-icon-primary-bg': '#feebeb',
  'components-badges-badge-icon-primary-fg': '#f62828',
  'components-badges-badge-icon-success-bg': '#dbefdc',
  'components-badges-badge-icon-success-fg': '#4caf50',
  'components-badges-badge-icon-warning-bg': '#ffeacc',
  'components-badges-badge-icon-warning-fg': '#ff9800',
  'components-badges-badge-tag-bg-accent': '#f62828',
  'components-badges-badge-tag-bg-accent-invert': '#feebeb',
  'components-badges-badge-tag-bg-dark': 'rgba(10, 10, 10, 0.60)',
  'components-badges-badge-tag-bg-dark-invert': '#d6d6d6',
  'components-badges-badge-tag-bg-error': '#f62828',
  'components-badges-badge-tag-bg-error-invert': '#feebeb',
  'components-badges-badge-tag-bg-info': '#3344ff',
  'components-badges-badge-tag-bg-info-invert': '#d6daff',
  'components-badges-badge-tag-bg-neutral': 'rgba(10, 10, 10, 0.60)',
  'components-badges-badge-tag-bg-neutral-invert': '#d6d6d6',
  'components-badges-badge-tag-bg-primary': '#f62828',
  'components-badges-badge-tag-bg-primary-invert': '#feebeb',
  'components-badges-badge-tag-bg-success': '#4caf50',
  'components-badges-badge-tag-bg-success-invert': '#dbefdc',
  'components-badges-badge-tag-bg-warning': '#ff9800',
  'components-badges-badge-tag-bg-warning-invert': '#ffeacc',
  'components-badges-badge-tag-fg-accent': '#ffffff',
  'components-badges-badge-tag-fg-accent-invert': '#f62828',
  'components-badges-badge-tag-fg-dark': '#ffffff',
  'components-badges-badge-tag-fg-dark-invert': '#0a0a0a',
  'components-badges-badge-tag-fg-error': '#ffffff',
  'components-badges-badge-tag-fg-error-invert': '#f62828',
  'components-badges-badge-tag-fg-info': '#ffffff',
  'components-badges-badge-tag-fg-info-invert': '#3344ff',
  'components-badges-badge-tag-fg-neutral': '#ffffff',
  'components-badges-badge-tag-fg-neutral-invert': '#0a0a0a',
  'components-badges-badge-tag-fg-primary': '#ffffff',
  'components-badges-badge-tag-fg-primary-invert': '#f62828',
  'components-badges-badge-tag-fg-success': '#ffffff',
  'components-badges-badge-tag-fg-success-invert': '#4caf50',
  'components-badges-badge-tag-fg-warning': '#ffffff',
  'components-badges-badge-tag-fg-warning-invert': '#ff9800',
  'components-bottom-bar-bg': '#0a0a0a',
  'components-bottom-bar-bg-button': '#f62828',
  'components-bottom-bar-fg': '#8a8a8a',
  'components-bottom-bar-fg-button': '#ffffff',
  'components-bottom-bar-icon-active': '#ffffff',
  'components-bottom-bar-text-active': '#ffffff',
  'components-button-primary-bg': '#f62828',
  'components-button-primary-bg-hover': '#e10a0a',
  'components-button-primary-fg': '#ffffff',
  'components-button-quaternary-bg': '#d6d6d6',
  'components-button-quaternary-bg-hover': '#bdbdbd',
  'components-button-quaternary-fg': '#0a0a0a',
  'components-button-quaternary-fg-hover': '#0a0a0a',
  'components-button-secondary-bg': 'rgba(255, 255, 255, 0.0)',
  'components-button-secondary-bg-hover': 'rgba(255, 255, 255, 0.0)',
  'components-button-secondary-border': '#f62828',
  'components-button-secondary-border-hover': '#e10a0a',
  'components-button-secondary-fg': '#f62828',
  'components-button-secondary-fg-hover': '#e10a0a',
  'components-button-tertiary-bg': '#ffffff',
  'components-button-tertiary-bg-hover': '#ffffff',
  'components-button-tertiary-fg': '#0a0a0a',
  'components-dropdown-bg': '#ffffff',
  'components-dropdown-bg-hover': '#f0f0f0',
  'components-dropdown-text': '#0a0a0a',
  'components-dropdown-text-active': '#f62828',
  'components-dropdown-text-disabled': '#707070',
  'components-footer-bg': '#ffffff',
  'components-footer-border': '#d6d6d6',
  'components-footer-text': '#8a8a8a',
  'components-game-topbar-bg-primary': '#f0f0f0',
  'components-game-topbar-bg-secondary': '#f0f0f0',
  'components-game-topbar-button-bg': '#ffffff',
  'components-game-topbar-button-fg': '#0a0a0a',
  'components-game-topbar-toggle-bg-active': '#0a0a0a',
  'components-game-topbar-toggle-bg-disabled': '#d6d6d6',
  'components-game-topbar-toggle-fg-active': '#0a0a0a',
  'components-game-topbar-toggle-fg-disabled': '#707070',
  'components-game-topbar-toggle-icon-active': '#ffffff',
  'components-game-topbar-toggle-icon-disabled': '#ffffff',
  'components-hamburger-bg-primary': '#ffffff',
  'components-hamburger-bg-secondary': '#f0f0f0',
  'components-hamburger-text-primary': '#0a0a0a',
  'components-hamburger-text-secondary': '#575757',
  'components-input-bg-disabled': '#f0f0f0',
  'components-input-border': '#d6d6d6',
  'components-input-border-focus': '#0a0a0a',
  'components-input-border-hover': '#bdbdbd',
  'components-input-fg-disabled': '#707070',
  'components-input-fg-error': '#f62828',
  'components-input-fg-primary': '#0a0a0a',
  'components-input-fg-secondary': '#575757',
  'components-menu-item-hamburger-bg-active': '#f0f0f0',
  'components-menu-item-hamburger-bg-hover': '#f0f0f0',
  'components-menu-item-hamburger-icon-active': '#f62828',
  'components-menu-item-hamburger-icon-disabled': '#8a8a8a',
  'components-menu-item-hamburger-icon-primary': '#0a0a0a',
  'components-menu-item-hamburger-icon-secondary': '#0a0a0a',
  'components-menu-item-hamburger-text': '#0a0a0a',
  'components-menu-item-hamburger-text-active': '#0a0a0a',
  'components-menu-item-hamburger-text-disabled': '#8a8a8a',
  'components-menu-item-section-bg-active': '#f0f0f0',
  'components-menu-item-section-bg-hover': '#f0f0f0',
  'components-menu-item-section-icon-active': '#f62828',
  'components-menu-item-section-icon-disabled': '#8a8a8a',
  'components-menu-item-section-icon-primary': '#0a0a0a',
  'components-menu-item-section-icon-secondary': '#0a0a0a',
  'components-menu-item-section-text': '#0a0a0a',
  'components-menu-item-section-text-active': '#0a0a0a',
  'components-menu-item-section-text-disabled': '#8a8a8a',
  'components-menu-item-sidebar-bg-active': '#f0f0f0',
  'components-menu-item-sidebar-bg-hover': '#f0f0f0',
  'components-menu-item-sidebar-icon-active': '#f62828',
  'components-menu-item-sidebar-icon-disabled': '#8a8a8a',
  'components-menu-item-sidebar-icon-primary': '#0a0a0a',
  'components-menu-item-sidebar-icon-secondary': '#0a0a0a',
  'components-menu-item-sidebar-text': '#0a0a0a',
  'components-menu-item-sidebar-text-active': '#0a0a0a',
  'components-menu-item-sidebar-text-disabled': '#8a8a8a',
  'components-modals-bg-body': '#ffffff',
  'components-modals-bg-button': '#ffffff',
  'components-modals-bg-button-inverse': '#f62828',
  'components-modals-bg-footer': '#ffffff',
  'components-modals-bg-footer-secondary': '#f0f0f0',
  'components-modals-bg-header': '#ffffff',
  'components-modals-bg-header-button': '#ffffff',
  'components-modals-bg-header-button-hover': '#f0f0f0',
  'components-modals-bg-header-inverse': '#f62828',
  'components-modals-bg-header-inverse-button': '#f62828',
  'components-modals-bg-header-inverse-button-hover': '#f62828',
  'components-modals-bg-overlay': 'rgba(10, 10, 10, 0.80)',
  'components-modals-fg-header': '#0a0a0a',
  'components-modals-fg-header-button': '#0a0a0a',
  'components-modals-fg-header-button-hover': '#0a0a0a',
  'components-modals-fg-header-inverse': '#ffffff',
  'components-modals-fg-header-inverse-button': '#ffffff',
  'components-modals-fg-header-inverse-button-hover': '#ffffff',
  'components-prize-progress-bg': '#bdbdbd',
  'components-prize-progress-bg-active': '#f62828',
  'components-prize-progress-bg-disabled': '#d6d6d6',
  'components-prize-progress-fg': '#0a0a0a',
  'components-prize-progress-fg-active': '#ffffff',
  'components-prize-progress-fg-disabled': '#575757',
  'components-scroll-bg': '#d6d6d6',
  'components-scroll-bg-hover': '#bdbdbd',
  'components-sidebar-bg-body': '#ffffff',
  'components-step-item-bg': '#f0f0f0',
  'components-step-item-counter-bg': '#f62828',
  'components-step-item-counter-fg': '#ffffff',
  'components-step-item-fg': '#0a0a0a',
  'components-step-item-fg-secondary': '#575757',
  'components-tab-circle-bg': '#ffffff',
  'components-tab-circle-bg-hover': '#d6d6d6',
  'components-tab-circle-border': '#f0f0f0',
  'components-tab-circle-border-active': '#f62828',
  'components-tab-circle-counter-bg': '#f62828',
  'components-tab-circle-counter-text': '#ffffff',
  'components-tab-circle-fg': '#0a0a0a',
  'components-tab-circle-fg-active': '#f62828',
  'components-tab-circle-fg-disabled': '#bdbdbd',
  'components-tab-horizontal-bg': '#ffffff',
  'components-tab-horizontal-bg-active': '#f62828',
  'components-tab-horizontal-bg-highlighted': '#f62828',
  'components-tab-horizontal-bg-hover': '#d6d6d6',
  'components-tab-horizontal-counter-bg': '#f62828',
  'components-tab-horizontal-counter-bg-active': '#d6d6d6',
  'components-tab-horizontal-counter-text': '#ffffff',
  'components-tab-horizontal-counter-text-active': '#0a0a0a',
  'components-tab-horizontal-fg': '#0a0a0a',
  'components-tab-horizontal-fg-active': '#ffffff',
  'components-tab-horizontal-fg-disabled': '#bdbdbd',
  'components-tab-horizontal-fg-highlighted': '#ffffff',
  'components-tab-underline-border': '#d6d6d6',
  'components-tab-underline-border-active': '#f62828',
  'components-tab-underline-border-disabled': '#d6d6d6',
  'components-tab-underline-border-hover': '#0a0a0a',
  'components-tab-underline-counter-bg': '#f62828',
  'components-tab-underline-counter-text': '#ffffff',
  'components-tab-underline-fg': '#0a0a0a',
  'components-tab-underline-fg-active': '#f62828',
  'components-tab-underline-fg-disabled': '#bdbdbd',
  'components-tab-vertical-bg': 'rgba(255, 255, 255, 0.10)',
  'components-tab-vertical-bg-active': '#4e0303',
  'components-tab-vertical-bg-highlighted': '#f62828',
  'components-tab-vertical-bg-hover': 'rgba(255, 255, 255, 0.20)',
  'components-tab-vertical-counter-bg': '#f62828',
  'components-tab-vertical-counter-text': '#ffffff',
  'components-tab-vertical-fg': '#ffffff',
  'components-tab-vertical-fg-active': '#f62828',
  'components-tab-vertical-fg-disabled': '#bdbdbd',
  'components-tab-vertical-fg-highlighted': '#ffffff',
  'components-tag-bg': '#d6d6d6',
  'components-tag-bg-active': '#0a0a0a',
  'components-tag-bg-disabled': '#f0f0f0',
  'components-tag-bg-hover': '#bdbdbd',
  'components-tag-text': '#0a0a0a',
  'components-tag-text-active': '#ffffff',
  'components-tag-text-disabled': '#a3a3a3',
  'components-toggles-bg-active': '#0a0a0a',
  'components-toggles-border': '#0a0a0a',
  'components-toggles-disabled': '#a3a3a3',
  'components-toggles-fg': '#ffffff',
  'components-toggles-switch-bg': '#d6d6d6',
  'components-toggles-switch-bg-selected-disabled': '#a3a3a3',
  'components-toggles-switch-fg-disabled': '#f0f0f0',
  'components-tooltips-bg': '#0a0a0a',
  'components-tooltips-text': '#ffffff',
  'components-top-bar-bg': '#f0f0f0',
  'components-top-bar-bg-button': '#ffffff',
  'components-top-bar-bg-button-active': '#f62828',
  'components-top-bar-fg-button-active': '#ffffff',
  'components-top-bar-fg-button-primary': '#0a0a0a',
  'components-top-bar-fg-button-secondary': '#f62828',
  'font-family-body': 'Poppins, "Poppins Fallback", Arial',
  'font-family-heading': '"Paytone One", "Paytone One Fallback", Arial',
  'font-family-title': 'Poppins, "Poppins Fallback", Arial',
  'font-letter-spacing-body-10': -0.20000000298023224,
  'font-letter-spacing-body-12': -0.23999999463558197,
  'font-letter-spacing-body-14': -0.2800000011920929,
  'font-letter-spacing-body-16': -0.3199999928474426,
  'font-letter-spacing-body-18': -0.36000001430511475,
  'font-letter-spacing-body-20': -0.4000000059604645,
  'font-letter-spacing-body-24': -0.47999998927116394,
  'font-letter-spacing-body-8': -0.1599999964237213,
  'font-letter-spacing-heading-10': -0.20000000298023224,
  'font-letter-spacing-heading-12': -0.23999999463558197,
  'font-letter-spacing-heading-14': -0.2800000011920929,
  'font-letter-spacing-heading-16': -0.3199999928474426,
  'font-letter-spacing-heading-18': -0.36000001430511475,
  'font-letter-spacing-heading-20': -0.4000000059604645,
  'font-letter-spacing-heading-24': -0.47999998927116394,
  'font-letter-spacing-heading-32': -0.6399999856948853,
  'font-letter-spacing-heading-36': -0.7200000286102295,
  'font-letter-spacing-heading-8': -0.1599999964237213,
  'font-letter-spacing-title-10': -0.20000000298023224,
  'font-letter-spacing-title-12': -0.23999999463558197,
  'font-letter-spacing-title-14': -0.2800000011920929,
  'font-letter-spacing-title-16': -0.3199999928474426,
  'font-letter-spacing-title-18': -0.36000001430511475,
  'font-letter-spacing-title-20': -0.4000000059604645,
  'font-letter-spacing-title-24': -0.47999998927116394,
  'font-letter-spacing-title-8': -0.1599999964237213,
  'font-line-height-body-10': 15,
  'font-line-height-body-12': 18,
  'font-line-height-body-14': 21,
  'font-line-height-body-16': 24,
  'font-line-height-body-18': 27,
  'font-line-height-body-20': 30,
  'font-line-height-body-24': 36,
  'font-line-height-body-8': 12,
  'font-line-height-heading-10': 12,
  'font-line-height-heading-12': 18,
  'font-line-height-heading-14': 17,
  'font-line-height-heading-16': 19,
  'font-line-height-heading-18': 22,
  'font-line-height-heading-20': 24,
  'font-line-height-heading-24': 29,
  'font-line-height-heading-32': 38,
  'font-line-height-heading-36': 43,
  'font-line-height-heading-8': 10,
  'font-line-height-title-10': 12,
  'font-line-height-title-12': 18,
  'font-line-height-title-14': 17,
  'font-line-height-title-16': 19,
  'font-line-height-title-18': 22,
  'font-line-height-title-20': 24,
  'font-line-height-title-24': 29,
  'font-line-height-title-8': 10,
  'font-size-body-10': 10,
  'font-size-body-12': 12,
  'font-size-body-14': 14,
  'font-size-body-16': 16,
  'font-size-body-18': 18,
  'font-size-body-20': 20,
  'font-size-body-24': 24,
  'font-size-body-8': 8,
  'font-size-heading-10': 10,
  'font-size-heading-12': 12,
  'font-size-heading-14': 14,
  'font-size-heading-16': 16,
  'font-size-heading-18': 18,
  'font-size-heading-20': 20,
  'font-size-heading-24': 24,
  'font-size-heading-32': 32,
  'font-size-heading-36': 36,
  'font-size-heading-8': 8,
  'font-size-title-10': 10,
  'font-size-title-12': 12,
  'font-size-title-14': 14,
  'font-size-title-16': 16,
  'font-size-title-18': 18,
  'font-size-title-20': 20,
  'font-size-title-24': 24,
  'font-size-title-8': 8,
  'font-weight-bold': 'Bold',
  'font-weight-extrabold': 'Regular',
  'font-weight-regular': 'Regular',
  'gradient-body': 'rgba(255, 255, 255, 0.0)',
  'gradient-bottom': 'rgba(255, 255, 255, 0.0)',
  'gradient-light-bottom': 'rgba(255, 255, 255, 0.0)',
  'gradient-light-left': 'rgba(255, 255, 255, 0.0)',
  'gradient-light-right': 'rgba(255, 255, 255, 0.0)',
  'gradient-top': 'rgba(255, 255, 255, 0.0)',
  'icon-accent': '#f62828',
  'icon-accent-subtle': '#feebeb',
  'icon-brand': '#f62828',
  'icon-brand-subtle': '#feebeb',
  'icon-primary': '#0a0a0a',
  'icon-primary-inverse': '#ffffff',
  'icon-secondary': '#575757',
  'icon-secondary-subtle': '#d6d6d6',
  'icon-state-error': '#f62828',
  'icon-state-error-subtle': '#feebeb',
  'icon-state-info': '#3344ff',
  'icon-state-info-subtle': '#d6daff',
  'icon-state-success': '#4caf50',
  'icon-state-success-subtle': '#dbefdc',
  'icon-state-warning': '#ff9800',
  'icon-state-warning-subtle': '#ffeacc',
  'radius-components-badge': 999,
  'radius-components-button': 999,
  'radius-components-input': 999,
  'radius-components-sidebar-nav': 999,
  'radius-components-tag-medium': 999,
  'radius-components-tag-small': 999,
  'radius-primary': 24,
  'radius-quaternary': 8,
  'radius-rounded': 999,
  'radius-secondary': 16,
  'radius-tertiary': 12,
  'text-accent': '#f62828',
  'text-brand': '#f62828',
  'text-link': '#f62828',
  'text-link-disabled': '#575757',
  'text-link-hover': '#e10a0a',
  'text-link-secondary': '#f62828',
  'text-link-secondary-disabled': '#575757',
  'text-link-secondary-hover': '#e10a0a',
  'text-on-dark-image': '#ffffff',
  'text-on-light-image': '#0a0a0a',
  'text-primary': '#0a0a0a',
  'text-primary-inverse': '#ffffff',
  'text-quaternary': '#8a8a8a',
  'text-secondary': '#575757',
  'text-state-error': '#f62828',
  'text-state-info': '#3344ff',
  'text-state-success': '#4caf50',
  'text-state-warning': '#ff9800',
  'text-tertiary': '#707070'
} as const;

// Full map = primitives + semantics (primitives first, then semantics on key collision).
export const appTsCssVars = {
  ...primitiveTsCssVars,
  ...semanticTsCssVars
} as const;

export type PrimitiveTsCssVars = typeof primitiveTsCssVars;

export type SemanticTsCssVars = typeof semanticTsCssVars;

export type AppTsCssVars = typeof appTsCssVars;

export type PrimitiveTsCssVarKey = keyof PrimitiveTsCssVars;

export type SemanticTsCssVarKey = keyof SemanticTsCssVars;

export type AppTsCssVarKey = keyof AppTsCssVars;
